module.exports = __webpack_public_path__ + "img/Arrow.0f932717.svg";